import React from 'react';
import { Button, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@mui/material';

function NotificationConfirmDialog({ open, onClose, onConfirm, type, recipients }) {
  const hasRecipients = recipients.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 0.5 }}>Send {type === 'load' ? 'load' : 'unload'} notification</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {hasRecipients
            ? `A notification will be sent to the following recipient${recipients.length > 1 ? 's' : ''}.`
            : 'No notification recipients are configured for this contract.'}
        </Typography>

        {hasRecipients && (
          <List disablePadding dense>
            {recipients.map(r => {
              const isEmail = r.notificationType === 'email';
              return (
                <ListItem key={`${r.notificationType}::${r.emailOrPhone}`} disableGutters>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    {isEmail ? (
                      <EmailIcon fontSize="small" color="action" />
                    ) : (
                      <PhoneAndroidIcon fontSize="small" color="action" />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={r.emailOrPhone} primaryTypographyProps={{ fontSize: 13 }} />
                  <Chip
                    label={isEmail ? 'Email' : 'SMS'}
                    size="small"
                    variant="outlined"
                    color={isEmail ? 'info' : 'success'}
                    sx={{ fontSize: 11 }}
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} size="small">
          Cancel
        </Button>
        <Button onClick={onConfirm} size="small" variant="contained" startIcon={<SendIcon />} disabled={!hasRecipients}>
          Send notification
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NotificationConfirmDialog;
